import React from 'react';

import GG_loader from '../../../general_components/GG_loader/GG_loader.js';
import { Redirect } from 'react-router-dom';
import { tryHandoffFcOauthToOpener } from '../../../Payment_methods/instant_bank/instantBankShared';
import { logEvent } from '../../../../utils/analytics';

/**
 * OAuth return handler for Stripe Financial Connections (sender bank add only).
 */
class Callback_fc_oauth extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            redirect_to: '',
            handedOffToOpener: false,
        };
    }

    componentDidMount() {
        // get the data from local storage
        const fc_return_session = window.location.href;
        const fc_client_secret = JSON.parse(localStorage.getItem('fc_client_secret'));
        const flow_type = JSON.parse(localStorage.getItem('fc_oauth_flow'));
        const user = JSON.parse(localStorage.getItem('user'));
        
        if (flow_type === 'pm') {
            const gift = JSON.parse(localStorage.getItem('gift'));
            const fc_gifting_url = JSON.parse(localStorage.getItem('fc_gifting_url'));

            if (!user || !gift || !fc_gifting_url || !fc_client_secret) {
                logEvent('add fund: oauth return failure', {
                    source: 'fc_oauth_return',
                    provider: 'financial_connections',
                    flow_type: 'pm',
                    error_code: 'missing_session_data',
                });
                window.location.href = '/home';
                return;
            }

            // --- Popup/second-tab OAuth: finish in the opener tab, close this one ---
            if (tryHandoffFcOauthToOpener()) {
                logEvent('add fund: oauth return success', {
                    source: 'fc_oauth_return',
                    provider: 'financial_connections',
                    flow_type: 'pm',
                    handoff_to_opener: true,
                });
                this.setState({ loading: false, handedOffToOpener: true });
                return;
            }

            // --- Same-tab OAuth: resume FC on this tab after redirect ---
            logEvent('add fund: oauth return success', {
                source: 'fc_oauth_return',
                provider: 'financial_connections',
                flow_type: 'pm',
            });
            this.props.update_fc_oauth(fc_client_secret, fc_return_session);

            const url = new URL(fc_gifting_url);
            const redirectTo = url.pathname + (url.search || '');
            this.setState({ loading: false, redirect_to: redirectTo });
            return;
        }

        logEvent('add fund: oauth return failure', {
            source: 'fc_oauth_return',
            provider: 'financial_connections',
            flow_type: flow_type || 'unknown',
            error_code: 'unsupported_flow',
        });
        window.location.href = '/home';
    }

    render() {
        if (this.state.loading) {
            return (
                <main>
                    <GG_loader />
                </main>
            );
        }

        if (this.state.handedOffToOpener) {
            return (
                <main>
                    <GG_loader header_text="Returning to your gift..." />
                    <p className="small_text" style={{ textAlign: 'center', marginTop: '16px' }}>
                        You can close this tab if it does not close automatically.
                    </p>
                </main>
            );
        }

        return (
            <main>
                <Redirect push to={this.state.redirect_to} />
            </main>
        );
    }
}

export default Callback_fc_oauth;
